import {
  POPUP_ITEM_DATA_INTER,
  POPUP_ITEM_DATA_RAW_INTER,
  POPUP_STATUS_VIEW,
} from './constant';
import { convertDateToDDMMYYYY } from '../../lib/lang/service';
import { LANG_STATUS_VIEW } from '../../lib/lang/value';
import { i18n } from '../../lib/lang';

export const convert = (list: POPUP_ITEM_DATA_RAW_INTER[]): any => {
  return list.map((popup) => ({
    ...popup,
    deadlineView: convertDateToDDMMYYYY(popup.deadline),
    status: [
      {
        value: popup.status,
        label: i18n.t(POPUP_STATUS_VIEW[popup.status]),
      },
    ],
    lang: [
      {
        value: popup.lang,
        label: LANG_STATUS_VIEW[popup.lang],
      },
    ],
  }));
};
